export const dropParams = [
  {
    name: "FBEC2024",
    path: "https://www.fbec.info/jintuoluo2024/index.html#/"
  },
  {
    name: "FBEC2023",
    path: "https://www.fbec.info/jintuoluo2023/index.html#/"
  },
  {
    name: "FBEC2022",
    path: "https://www.fbec.info/jintuoluo2022/index.html#/"
  },
  {
    name: "FBEC2021",
    path: "https://www.fbec.info/jintuoluo2021/index.html#/"
  },
  {
    name: "FBEC2020",
    path: "https://www.fbec.info/jintuoluo2020/index.html#/"
  },
  {
    name: "FBEC2019",
    path: "https://www.fbec.info/jintuoluo2019/index.html"
  },
  {
    name: "FBEC2018",
    path: "http://www.youxituoluo.com/jintuoluo2018"
  },
  {
    name: "第二届金陀螺奖",
    path: "http://www.youxituoluo.com/jintuoluo2017"
  },
  {
    name: "首届金陀螺奖",
    path: "http://www.youxituoluo.com/jintuoluo2016"
  }
];



// WEBPACK FOOTER //
// ./src/utils/com_data.js